import api from '../../api/api_resource'
import axios from "axios";
import LaravelRouter from "../../thirdparty/Ziggy/route";
import {saveVuexState, getVuexState} from "../../util/common";
import de from "element-ui/src/locale/lang/de";

const defaults = {
    ids: [],
    all: [],
    current_page: 1,
    per_page: 500,
    from: 0,
    to: 0,
    last_page: null,
    total: null,
}

const saveState = state => {
    const state_to_save = {
        ...JSON.parse(JSON.stringify(state)),
        ...defaults //override some of the defaults
    }
    saveVuexState('vehicle_stock_state', state_to_save)
}
const state = getVuexState('vehicle_stock_state', {
    ...defaults,
    makes: [],
    models: [],
    single_vehicle: {}, //to be set on the search list for quick viewing on the single page...
    single_next: {},
    single_prev: {},
});

// getters
const getters = {
    all: state => state.all,
    ids: state => state.ids,
    currentPage: state => state.current_page,
    single_vehicle: state => state.single_vehicle,
    single_prev: state => state.single_prev,
    single_next: state => state.single_next,
};
const getVehicles = async (endpoint, args, cancelToken = axios.CancelToken.source()) => {
    try{
        const search_args = Object.assign({
            page: state.current_page,
            per_page: state.per_page,
        }, args);
        let vehicle_stock = await api.get(`vehicle-stock.${endpoint}`, [], search_args, cancelToken)
        return vehicle_stock;
    } catch (e) {
        console.warn('err getting vehicles', e)
    }
}
// actions
const actions = {
    async get({commit, state}, {endpoint, args, cancelToken} = {cancelToken: axios.CancelToken.source()}) {
        let res =  await getVehicles(endpoint, args, cancelToken)
        commit('setVehicleStock', res);
    },

    storeVehicleStock({commit, state}, args) {
        return new Promise((success, error) => {
            let formData = makeFormDataWithArraysAndObjects(args.data);

            api.store('vehicle-stock', formData).then(vehicle_stock => {
                success(vehicle_stock);
            }).catch(errors => {
                error(errors.response.data);
            });
        });
    },
    updateVehicleStock({commit, state}, args) {
        return new Promise((success, error) => {
            let route = LaravelRouter(`vehicle-stock.update`, args.id, true);

            axios.put(route, args.data).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response.response.data);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
    updateOfferImages({commit, state}, {id, data, cancelToken = axios.CancelToken.source()}) {
        return new Promise((success, error) => {
            let route = LaravelRouter(`vehicle-stock.update-offer-images`, id, true);
            axios.put(route, data, {
                cancelToken: cancelToken.token
            }).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response.response.data);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
    updateRepNote({commit, state}, {id, data, cancelToken = axios.CancelToken.source()}) {
        return new Promise((success, error) => {
            let route = LaravelRouter(`vehicle-stock.updateRepNote`, id, true);
            axios.put(route, data, {
                cancelToken: cancelToken.token
            }).then(response => {
                if (response && response.data && response.data) {
                    commit('updateVehicleStock', {vehicle: response.data.vehicle, field: 'rep_note'})
                    success(response.data)
                } else {
                    error(response.response.data);
                }
            }).catch(response => {
                error(response);
            });
        });
    },


    async setActiveImages({commit, state}, data) {
        try {
            let route = LaravelRouter(`vehicle-stock.setActiveImages`, true);
            let response = await axios.post(route, {vehicles: data})
            if (response && response.data && response.data.image) {
                return response.data.image
            }
        } catch (e) {
            console.warn('exception in setVehicleImageActive', e)
        }
        return null;
    },

    deleteVehicleStock({commit, state}, vehicle_stock) {
        return new Promise((success, error) => {
            api.destroy('vehicle-stock', vehicle_stock.id).then(vehicle_stock => {
                success(vehicle_stock);
            }).catch(error => {
                //console.log(error.response.data);
                return false;
            });
        });
    },

    deleteVehicleStockMessage({commit, state}, {message_id, stock_id}) {
        console.log('deleteVehicleStockMessage', {message_id, stock_id})
        return new Promise((success, error) => {

            let route = LaravelRouter('vehicle-stock.deleteMessage', {vehicleStockMessage: message_id}, true);
            axios.delete(route).then(vehicle_stock => {
                console.log('delete stock message res', vehicle_stock)
                if (stock_id) {
                    console.log('stock id set')
                    commit('removeStockMessage', {message_id, stock_id})
                } else {
                    console.log('stock id not set')
                }
                success(vehicle_stock);
            }).catch(err => {
                //console.log(error.response.data);
                error(err)
            });
        });
    },

    addVehicleStockImage({commit, state}, args) {
        return new Promise((success, error) => {
            let route = `/vehicle-stock/${args.vehicle_stock_id}/add-image`;
            let formData = new FormData();
            formData.append('image', args.image);
            axios.post(route, formData).then(response => {
                if (response && response.data) {
                    success(response.data)
                } else {
                    error(response.response.data);
                }
            }).catch(errors => {
                error(errors.response.data);
            })
        });
    },


    syncWithHewia({commit, state}, vehicle_stock_id) {
        return new Promise((success, error) => {
            let route = `/vehicle-stock/${vehicle_stock_id}/sync-with-hewia`;
            axios.get(route).then(response => {
                if (response && response.data) {
                    success(response.data)
                } else {
                    error(response.response.data);
                }
            }).catch(errors => {
                error(errors.response.data);
            })
        });
    },

    deleteVehicleStockImage({commit, state}, args) {
        return new Promise((success, error) => {
            let route = `/vehicle-stock/${args.vehicle_stock_id}/delete-image/${args.id}`;
            axios.delete(route).then(response => {
                if (response && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(errors => {
                error(errors.response.data);
            })
        });
    },

    toggleActiveVehicleStockImage({commit, state}, args) {
        return new Promise((success, error) => {
            let route = `/vehicle-stock/${args.vehicle_stock_id}/toggle-active-image/${args.id}`;
            axios.patch(route).then(response => {
                if (response && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(errors => {
                error(errors.response.data);
            })
        });
    },
    /**
     *
     * @param args.vehicle_stock_ids int[]
     * @param args.user_ids int[]
     * @param args.message string
     * @returns {Promise<>}
     */
    sendStockEmail({commit, state}, args){
        return new Promise((success, error) => {
            const vehicle_stock_ids = args.vehicle_stock_ids
            const user_ids = args.user_ids
            const message = args.message
            const subject = args.subject
            const from_user = args.from_user
            api.post('vehicle-stock.sendEmail',
                {},
                {vehicle_stock_ids, user_ids, subject, message, from_user}).then(res => {
                success(res);
            }).catch(error);
        });
    },
    buyNowRequest({commit, state}, args) {
        return new Promise((success, error) => {
            let route = `/vehicle-stock/${args.vehicle_stock_id}/buy-now`;
            let orderData = args.order;
            axios.post(route, orderData).then(response => {
                if (response && response.data) {
                    success(response.data)
                } else {
                    error(response.response.data);
                }
            }).catch(errors => {
                error(errors.response.data);
            });
        });
    },
    addMessage({ commit, state }, args) {
        return new Promise((success, error) => {
            api.post('vehicle-stock.addMessage', args.vehicle_stock_id, args).then(res => {
                success(res);
            }).catch(error);
        });
    },
    async getMakes({commit}){
        try {
            let res = await api.get('vehicle-stock.getMakes');
            if (res.makes) {
                commit('setMakes', res.makes)
                return res.makes;
            }
        } catch (e) {
            console.warn('exception in getMakes', e);
        }
        return null;
    },
    async getModels({commit}, make){
        try {
            let res = await api.get('vehicle-stock.getModels',{make});
            if (res.models) {
                commit('setModels', res.models)
                return res.models;
            }
        } catch (e) {
            console.warn('exception in getModels', e);
        }
        return null;
    },
};

function makeFormDataWithArraysAndObjects(args) {
    let formData = new FormData();
    for (let key in args) {
        // for arrays - fill formData like array[] =
        if (Array.isArray(args[key])) {
            args[key].forEach(element => {
                // objects - convert to json
                if (element instanceof Object)
                    element = JSON.stringify(element);
                formData.append(`${key}[]`, element)
            });
        } else if (args[key] || args[key] === 0) {
            let value = args[key];
            if (value instanceof Object)
                value = JSON.stringify(value);
            formData.append(key, value);
        }
    }

    return formData;
}

// mutations
const mutations = {
    updateVehicleStock(state, {vehicle, field = null}){
        let key = null
        state.all.forEach((item, i) => {
            if (item.id === vehicle.id) {
                key = i;
            }
        })
        if (key !== null) {
            if (field) {
                state.all[key][field] = vehicle[field]
            } else {
                state.all[key] = vehicle
            }
            saveState(state)
        }

    },
    setVehicleStock(state, result) {
        state.all = result.data;
        const ids = []
        if (result.data && result.data.length) {
            result.data.forEach(v => ids.push(v.id))
        }
        state.ids = ids
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
        saveState(state)
    },

    setRequests(state, result) {
        state.requests = result.data;//.map(item => {item._showDetails = true; return item;});
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
        saveState(state)
    },


    setSingleVehicle (state, vehicle) {
        state.single_vehicle = vehicle
        saveState(state)
    },
    setSingleNext (state, vehicle) {
        state.single_next = vehicle
        saveState(state)
    },
    setSinglePrev (state, vehicle) {
        state.single_prev = vehicle
        saveState(state)
    },

    setUserId(state, result) {
        state.user_id = result.user_id;
        saveState(state)
    },

    setPerPage(state, result) {
        state.per_page = result;
        saveState(state)
    },

    setMakes(state, makes) {
        state.makes = makes;
        saveState(state)
    },
    setModels(state, models) {
        state.models = models;
        saveState(state)
    },

    addMessage(state, data) {
        state.all.forEach(vehicleStock => {
            if (vehicleStock.id === data.id) {
                if (!vehicleStock.messages) {
                    vehicleStock.messages = [];
                }
                vehicleStock.messages.push(data.message);
            }
        });
        saveState(state)
    },
    setCurrentPage(state, page) {
        state.page = page
        saveState(state)
    },
    removeStockMessage(state, {message_id, stock_id}){
        state.all.map(stock => {
            if (stock.id === stock_id) {
                let index = null;
                stock.messages.forEach((msg, i) => {
                    if (msg.id === message_id) {
                        index = i
                    }
                })
                if (index !== null) {
                    stock.messages.splice(index, 1);
                }
            }
            return stock
        })
        saveState(state)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/vehicleStock.js